import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [CommonModule, MaterialModule, MatProgressSpinner],
    providers: [],
    standalone: true
})
export class LoadingComponent {
  constructor(public loadingService: LoadingService) { }
}